import { gql } from "@apollo/client";

export const SET_BOOKING_STATUS = gql`
  mutation SetStatusBookingReservation(
    $bookingSessionId: String!
    $status: BookingStatus!
    $description: String
  ) {
    setStatusBookingReservation(
      bookingSessionId: $bookingSessionId
      status: $status
      description: $description
    )
  }
`;

export const SET_BOOKING_CLIENT_STATUS = gql`
  mutation SetClientStatusBookingReservation(
    $bookingSessionId: String!
    $clientStatus: ClientStatus!
  ) {
    setClientStatusBookingReservation(
      bookingSessionId: $bookingSessionId
      clientStatus: $clientStatus
    )
  }
`;

export const CREATE_BOOKING_USER = gql`
  mutation CreateBookingReservation(
    $bookedDate: DateTime
    $bookedHour: String
    $numberOfGuests: Int!
    $duration: Int
    $bookingModuleId: String!
    $areaId: String
    $tableId: [String]
    $description: String
    $specialRequirements: ReservationSpecialRequirements
    $agreedToCampaign: Boolean
  ) {
    createBookingReservation(
      bookedDate: $bookedDate
      bookedHour: $bookedHour
      numberOfGuests: $numberOfGuests
      duration: $duration
      bookingModuleId: $bookingModuleId
      areaId: $areaId
      tableId: $tableId
      description: $description
      specialRequirements: $specialRequirements
      agreedToCampaign: $agreedToCampaign
    )
  }
`;
export const CREATE_BOOKING_HOLDING_FEE_USER = gql`
  mutation CreateCartBookingHoldingFee(
    $metadata: CartBookingHoldingFee
    $quantity: Int
    $ticketId: ID
  ) {
    createCartBookingHoldingFee(
      metadata: $metadata
      quantity: $quantity
      ticketId: $ticketId
    ) {
      id
      items {
        id
        metadata
        quantity
        seatIds
        seatsHoldToken
      }
    }
  }
`;

export const CREATE_BOOKING = gql`
  mutation CreateBookingReservation(
    $bookedDate: DateTime!
    $bookedHour: String!
    $numberOfGuests: Int!
    $duration: Int!
    $bookingModuleId: String!
    $companyAdded: ReservationCompanyAdded
    $areaId: String
    $tableId: [String]
    $description: String
    $specialRequirements: ReservationSpecialRequirements
  ) {
    createBookingReservation(
      bookedDate: $bookedDate
      bookedHour: $bookedHour
      numberOfGuests: $numberOfGuests
      duration: $duration
      bookingModuleId: $bookingModuleId
      companyAdded: $companyAdded
      areaId: $areaId
      tableId: $tableId
      description: $description
      specialRequirements: $specialRequirements
    )
  }
`;

export const RESCHEDULE_BOOKING = gql`
  mutation RescheduleBookingReservation(
    $sessionId: String!
    $bookedDate: DateTime!
    $bookedHour: String!
    $numberOfGuests: Int!
    $duration: Int!
    $bookingModuleId: String!
    $tableId: [String]
    $areaId: String
    $description: String
    $specialRequirements: ReservationSpecialRequirements
  ) {
    rescheduleBookingReservation(
      sessionId: $sessionId
      bookedDate: $bookedDate
      bookedHour: $bookedHour
      numberOfGuests: $numberOfGuests
      duration: $duration
      bookingModuleId: $bookingModuleId
      tableId: $tableId
      areaId: $areaId
      description: $description
      specialRequirements: $specialRequirements
    )
  }
`;

export const BLOCK_BOOKING_INTERVAL = gql`
  mutation BlockTablesBookingReservation(
    $bookingModuleId: String!
    $areaId: String!
    $bookedDate: DateTime!
    $startTime: String!
    $endTime: String!
    $tables: [String!]
    $description: String
  ) {
    blockTablesBookingReservation(
      bookingModuleId: $bookingModuleId
      areaId: $areaId
      bookedDate: $bookedDate
      startTime: $startTime
      endTime: $endTime
      tables: $tables
      description: $description
    )
  }
`;

export const CHECK_AVAILABILITY_BOOKING = gql`
  query CheckAvailabilityBookingmodule(
    $bookingModuleId: ID!
    $lookupYm: String
    $numberOfGuests: Int
    $bookedDate: String
    $areaId: String
    $bookedHour: String
    $duration: Int
    $showFirstAvailable: Boolean
  ) {
    checkAvailabilityBookingmodule(
      bookingModuleId: $bookingModuleId
      lookupYM: $lookupYm
      numberOfGuests: $numberOfGuests
      bookedDate: $bookedDate
      areaId: $areaId
      bookedHour: $bookedHour
      duration: $duration
      showFirstAvailable: $showFirstAvailable
    ) {
      dates {
        name
        status
      }
      bookedHours
      bookingModuleType
      durations
      areas {
        id
        name
        minHoldingFee
      }
      tables {
        id
        name
        capacity
        areaId
        status
      }
      areaCapacities { 
        areaId 
        totalCapacity 
        busyCapacity 
      }
      holdingFee
      enabledWaitlist
    }
  }
`;
